
































import { Vue, Prop, Component } from "vue-property-decorator";
import { Notification as INotification } from "@/api-v2/notification/models/notification";
import { notificationApi } from "@/getinfo-api";

@Component
export default class UserNotificationListItem extends Vue {
  @Prop() notification!: INotification;
  isLoading: boolean = false;

  async markedAsRead() {
    try {
      this.isLoading = true;
      const { data } = await notificationApi.Notification.readNotification(
        this.notification.id!
      );

      await this.$store.dispatch("successToast", {
        message: this.$tc(
          this.$translate.TheInformationHasBeenSuccessfullyChanged
        )
      });

      this.$emit("readNotification", data);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }
}
